import { Button, Stack, Typography } from '@mui/material';
import { TagHeading } from '@shared/components';
import AddIcon from '@mui/icons-material/Add';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  openCreateDialog?: () => void;
}

export const CampaignToolbar = ({ openCreateDialog }: Props) => {
  const t = useCampaignTFunction();

  return (
    <Stack flexDirection="row" justifyContent="space-between" alignItems="center" px={3}>
      <TagHeading color="primary">
        <Typography variant="h4">{t('campaign.campaignPlural')}</Typography>
      </TagHeading>
      {openCreateDialog && (
        <Button
          variant="liquid"
          size="small"
          sx={{ whiteSpace: 'nowrap' }}
          startIcon={<AddIcon fontSize="small" />}
          onClick={openCreateDialog}
        >
          {t('campaign.actions.createCampaign')}
        </Button>
      )}
    </Stack>
  );
};
